export const heroImages = require.context('../assets/img', true);